import React, { useState, useCallback } from 'react';
import cx from 'classnames';
import Img from '../../../../../../components/Img';
import Slider from '../../../../../../components/utils/Slider/Slider';
import {
  WIDGET_BANNER_SECTION_LAYOUT_INFO,
  WIDGET_LAYOUT_TYPE,
  WIDGET_TYPE,
} from '../../../../../../constants/service/app/widgetConstants';
import './WidgetPreviewBannerSwipeLayout.scss';

const WidgetPreviewBannerSwipeLayout = (props) => {
  const { list, layoutType } = props;
  const [float, setFloat] = useState('left');

  const onChange = useCallback(
    (oldIndex, newIndex) => {
      setTimeout(() => {
        const offsetIndex = WIDGET_BANNER_SECTION_LAYOUT_INFO[layoutType].SLIDE_TO_SHOW - 1;
        if (newIndex === list.length - 1 - offsetIndex) {
          setFloat('right');
        } else {
          setFloat('left');
        }
      }, 10);
    },
    [list, layoutType],
  );

  return (
    <Slider
      className={cx('widget-banner-swipe-layout', {
        /**
         *  스와이프(1.5개)
         */
        swipe_1_dot_5: layoutType === WIDGET_LAYOUT_TYPE[WIDGET_TYPE.BANNER].SWIPE_1_DOT_5,
        /**
         *  스와이프(2.5개)
         */
        swipe_2_dot_5: layoutType === WIDGET_LAYOUT_TYPE[WIDGET_TYPE.BANNER].SWIPE_2_DOT_5,
        'is-not-img-margin': WIDGET_BANNER_SECTION_LAYOUT_INFO[layoutType].IS_NOT_IMG_MARGIN,
        'is-float-right': float === 'right' && WIDGET_BANNER_SECTION_LAYOUT_INFO[layoutType].SLIDE_TO_SHOW,
        'is-float-left': float === 'left' && WIDGET_BANNER_SECTION_LAYOUT_INFO[layoutType].SLIDE_TO_SHOW,
      })}
      emptyText={'홈에 노출 될 위젯 아이템 리스트 설정해주세요.'}
      dots={WIDGET_BANNER_SECTION_LAYOUT_INFO[layoutType].IS_SWIPE_INDICATOR}
      list={list}
      arrows={false}
      infinite={false}
      beforeChange={WIDGET_BANNER_SECTION_LAYOUT_INFO[layoutType].SLIDE_TO_SHOW && onChange}
      slidesToShow={WIDGET_BANNER_SECTION_LAYOUT_INFO[layoutType].SLIDE_TO_SHOW}
      item={(storeItem) => (
        <div className="widget-banner-section">
          <Img clickAble={false} src={storeItem.url} />
        </div>
      )}
    />
  );
};

export default WidgetPreviewBannerSwipeLayout;
